import { Reveal, SectionTag, SectionTitle } from "@/components/bits";

const DELIVERABLES = [
  {
    num: "01",
    tag: "PDF",
    title: "1 libro completo en PDF",
    text: "El texto íntegro de cada autora: listo para leer, subrayar y volver.",
  },
  {
    num: "02",
    tag: null,
    title: "1 selección de textos curada",
    text: "Pasajes elegidos especialmente para este recorrido, por autora.",
  },
  {
    num: "03",
    tag: null,
    title: "1 guía de lectura por libro",
    text: "Ejes de análisis, hipótesis de críticos literarios y pasajes comentados que iluminan lo que no se ve en una lectura apurada.",
  },
  {
    num: "04",
    tag: null,
    title: "El lugar de la autora, en vivo",
    text: "Un recorrido por su lugar en la literatura argentina y por qué importa hoy, al inicio de cada encuentro.",
  },
  {
    num: "05",
    tag: null,
    title: "Disección crítica en vivo",
    text: "Un cuento o poema desarmado en la tertulia: cómo funciona, qué hace, dónde respira.",
  },
  {
    num: "06",
    tag: "LIVE",
    title: "Tertulia semanal en vivo",
    text: "Todos los lunes de 19 a 20 hs. Encuentro de discusión comparada entre autoras. Conversación íntima, voz con voz.",
  },
];

export default function Inversion() {
  return (
    <section id="inversion" data-testid="inversion-section" className="bg-ink py-20 sm:py-28 lg:py-36">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-3xl">
          <SectionTag>Inversión</SectionTag>
          <SectionTitle className="mt-6">Lo que vas a recibir</SectionTitle>
          <p className="mt-6 text-base font-light leading-relaxed text-ash sm:text-lg">
            Una experiencia diseñada para que leas con cuerpo y cabeza. Todo el material queda en tu poder.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-px bg-gold/10 md:grid-cols-2 lg:grid-cols-3">
          {DELIVERABLES.map((d, i) => (
            <Reveal key={d.num} delay={(i % 3) * 0.08}>
              <div data-testid={`inversion-item-${d.num}`} className="h-full bg-ink p-8 transition-colors duration-500 hover:bg-soot">
                <div className="flex items-baseline justify-between">
                  <p className="font-sans text-xs tracking-[0.3em] text-gold">{d.num}</p>
                  {d.tag && (
                    <span className="border border-crimson-light/60 px-2 py-0.5 font-sans text-[9px] uppercase tracking-[0.2em] text-gold">
                      {d.tag}
                    </span>
                  )}
                </div>
                <h3 className="mt-5 font-serif text-xl italic text-cream">{d.title}</h3>
                <p className="mt-3 text-sm font-light leading-relaxed text-ash">{d.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-14 text-center font-serif text-xl italic text-gold sm:text-2xl">
            4 autoras · 4 universos · una sola lectora distinta al final
          </p>
        </Reveal>
      </div>
    </section>
  );
}
